var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlossary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 6.125C8.76794 6.125 8.54538 6.21719 8.38128 6.38128C8.21719 6.54538 8.125 6.76794 8.125 7V20.8139L13.3461 17.0846C13.7373 16.8052 14.2627 16.8052 14.6539 17.0846L19.875 20.8139V7C19.875 6.76794 19.7828 6.54538 19.6187 6.38128C19.4546 6.21719 19.2321 6.125 19 6.125H9ZM6.79029 4.79029C7.37634 4.20424 8.1712 3.875 9 3.875H19C19.8288 3.875 20.6237 4.20424 21.2097 4.79029C21.7958 5.37634 22.125 6.1712 22.125 7V23C22.125 23.4214 21.8895 23.8075 21.5148 24.0003C21.1401 24.1931 20.689 24.1604 20.3461 23.9155L14 19.3825L7.65389 23.9155C7.31098 24.1604 6.85993 24.1931 6.48522 24.0003C6.11052 23.8075 5.875 23.4214 5.875 23V7C5.875 6.1712 6.20424 5.37634 6.79029 4.79029Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlossary);
export default __webpack_public_path__ + "static/media/glossary.3cf65b365e92ffe9e270e7c176366d82.svg";
export { ForwardRef as ReactComponent };